module.exports = __webpack_public_path__ + "static/Milan_Misak_Cuk-9beb4de11c23870c2764376ae1c752ec.mp3";